import { useIdentity } from '../../identity/state/useIdentity';
import { CompanyMembersPage } from '../../identity/pages/CompanyMembersPage';
import { RolesPermissionsPanel } from './RolesPermissionsPanel';

export function UsersPermissionsPage() {
  const { me } = useIdentity();
  if (!me?.activeCompanyId) {
    return (
      <section className="card card--wide">
        <p className="muted">Select a company to manage its users.</p>
      </section>
    );
  }

  return (
    <>
      <CompanyMembersPage companyId={me.activeCompanyId} />
      <RolesPermissionsPanel />
    </>
  );
}
